// vue
import { ref, reactive, computed, watch, ComputedRef, onMounted, onUnmounted, PropType } from 'vue';

// types
import { Props, Context, IBar, CurrentOrder } from '../../../types';

// useComputed
import { useComputed } from './computed';

// store
import { useGl } from '@store/ts/gl';
import { useRefs } from '@store/ts/refs';

// useGlobals
import { useGlobals } from './globals';

// useChart
import { useChart } from './chart';

// useOrders
import { useOrders } from './orders';

// props
export const generalProps = {
    exchange: {
        type: String as PropType<Props['exchange']>,
        required: true,
    },
    data: {
        type: Object as PropType<Props['data']>,
        required: true,
    },
};

declare global {
    interface Window {
        TradingView: any;
        Datafeeds: any;
    }
}

export const shared = (props: Readonly<Props>, context: Context) => {
    // store
    const gl = useGl();
    const refs = useRefs();

    // vars
    const isUpdatingPair = ref(false);
    
    // useGlobals
    const {
        init,
        barsGl,
        widget,
        chartContainer,
    } = useGlobals(props);
    
    // useComputed
    const {
        theme,
        overrides,
        pair,
        hardHideChart } = useComputed(props);

    // useChart
    const {
        interval,
        getBarsLoading,
        initScripts,
        initChartLibraty,
    } = useChart(props);

    // useOrders
    const {
        renderOrders,
        changeThemeOfOrders,
    } = useOrders(props);

    watch(() => props.data, () => {
        if (hardHideChart.value || getBarsLoading.value) return;

        if (!init.value) {
            // действия перед инициализацией

            if (pair.value != '') {
                initChartLibraty(pair.value);
            }
        } else {
            // действия после инициализации

            // пара на графике
            const currentSymbol = widget.value?.chart().symbol();

            // если пара уже была на графике
            // и пришло новое значение для нее
            if (currentSymbol != undefined && pair.value != currentSymbol) {
                // очищаем бары
                Object.keys(barsGl).forEach(key => {
                    delete barsGl[key];
                });

                // обновляем торговую пару для графика
                widget.value?.setSymbol(pair.value, widget.value.chart().resolution(), () => {
                    renderOrders(true);
                });
            } else {
                renderOrders(true);
            }
        }
    }, { deep: true });

    // watch(() => props.orders, v => {
    //     if (init.value) {
    //         if (!isUpdatingPair.value) {
    //             renderOrders();
    //         }
    //     }
    // }, { deep: true });
    
    // watch(pair, async (newValue, oldValue) => {
    //     if (!newValue) return;
    
    //     if (oldValue) {
    //         isUpdatingPair.value = true;
    //         // очищаем бары
    //         Object.keys(barsGl).forEach(key => {
    //             delete barsGl[key];
    //         });

    //         // обновляем торговую пару для графика
    //         widget.value?.setSymbol(newValue, widget.value.chart().resolution(), async () => {
    //             // Если во время блокировки пришли новые ордера, обновляем их
    //             await renderOrders(true);

    //             isUpdatingPair.value = false;
    //         });
    //     } else {
    //         await nextTick();
    //         await initChartLibraty(newValue);
    //     }
    // });

    watch(() => gl.darkTheme, async () => {
        if (init.value) {
            widget.value?.applyOverrides(overrides.value);
            widget.value?.changeTheme(theme.value);
            // changeThemeOfOrders();
            renderOrders(true);
        }
    });
    
    onMounted(() => {
        initScripts();
    });

    onUnmounted(() => {
        clearInterval(interval.value);
        init.value = false;
        widget.value?.remove();
    });

    return {
        init,
        refs,
        hardHideChart,
        chartContainer,
    };
};
